import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

const Info = ({ label, value, testid }) => (
  <div>
    <div className="text-[10px] font-mono-x uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className="font-semibold" data-testid={testid}>{value || "—"}</div>
  </div>
);

export default function Verifica() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/verifica/${id}`).then((r) => setD(r.data)).catch(() => setD(false));
  }, [id]);

  const ok = d && d.valida;
  return (
    <div className="min-h-screen bg-[#0B192C] grid place-items-center px-4 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl overflow-hidden shadow-2xl fade-up" data-testid="verifica-card">
        <div className="tricolore h-1.5" />
        <div className="p-8">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo-9er.png" alt="Logo" className="h-12 w-12" />
            <div className="font-heading uppercase text-lg leading-tight">Associazione italiana<br />Classi Nacra-9er</div>
          </div>
          {d === null && <p className="text-muted-foreground">Verifica in corso…</p>}
          {d === false && <p className="text-red-600 font-medium" data-testid="verifica-not-found">Tessera non trovata.</p>}
          {d && (
            <>
              <div className={`flex items-center gap-3 rounded-xl p-4 mb-6 ${ok ? "bg-emerald-50 text-emerald-800" : "bg-red-50 text-red-700"}`} data-testid="verifica-status">
                {ok ? <CheckCircle2 className="h-8 w-8" /> : <XCircle className="h-8 w-8" />}
                <div>
                  <div className="font-heading text-2xl uppercase">{ok ? "Tessera valida" : "Tessera non valida"}</div>
                  <div className="text-sm">{ok ? `Socio in regola per il ${d.anno}` : d.pagamento_confermato ? `Iscrizione scaduta (anno ${d.anno})` : "Pagamento non ancora confermato"}</div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <Info label="Socio" value={`${d.cognome} ${d.nome}`} testid="verifica-nominativo" />
                <Info label="N. tessera" value={d.tessera_numero} testid="verifica-tessera" />
                <Info label="Validità" value={`01/01 – 31/12/${d.anno}`} testid="verifica-anno" />
                <Info label="Categoria barca" value={d.categoria_barca} testid="verifica-barca" />
                <div className="col-span-2"><Info label="Categoria socio" value={d.categoria_socio} testid="verifica-categoria" /></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
